import { useState } from 'react';
import { ActiveFilter } from '../../../crawler/crawler.interface';
import Button from '../../button/button';
import './multiChipSelect.scss';

export interface MultiChipSelectProps {
    name: string;
    defaultSelectedChips?: MultiChipSelectOption[];
    options: MultiChipSelectOption[];
    handleSubmit: (filter: ActiveFilter) => void;
}

export interface MultiChipSelectOption {
    label: string;
    name: string;
    value: string;
}

const MultiChipSelect = ({ name, defaultSelectedChips = [], options, handleSubmit }: MultiChipSelectProps) => {

    const [selectedChips, setSelectedChips] = useState<MultiChipSelectOption[]>(() => checkForDefaultSelected());

    function checkForDefaultSelected() {
        return defaultSelectedChips ? defaultSelectedChips : [];
    }

    function handleClick(option: MultiChipSelectOption) {
        const currentSelectedChips = [...selectedChips];
        const index = currentSelectedChips?.findIndex((chip: MultiChipSelectOption) => chip.value == option.value);
        if (index === -1) {
            setSelectedChips([...currentSelectedChips, option]);
        } else {
            currentSelectedChips.splice(index, 1);
            setSelectedChips([...currentSelectedChips]);
        }
    }

    function isSelected(chipValue: string) {
        const currentSelectedChips = [...selectedChips];
        const index = currentSelectedChips?.findIndex((chip: MultiChipSelectOption) => chip.value == chipValue);
        return index === -1 ? '' : 'selected';
    }

    function submitMultiChips() {
        const filterVal = selectedChips.map((chip: MultiChipSelectOption) => chip.value).join('|');
        const filter: ActiveFilter = { name: name, value: filterVal };
        handleSubmit(filter);
    }

    return (
        <>
            <div className="multi-chip-wrapper">
                {options.map((option: MultiChipSelectOption) => (
                    <div className={"chip " + isSelected(option.value)} key={option.value} onClick={() => handleClick(option)}>
                        <span >{option.label}</span>
                    </div>
                ))}
            </div>
            <div className="center-button">
                <Button variant="button button--small" onClick={submitMultiChips}>Submit</Button>
            </div>
        </>
    );
};

export default MultiChipSelect;